"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedThemeProvider = exports.useSharedTheme = exports.SharedThemeContext = void 0;
const react_1 = __importStar(require("react"));
// We should use @ts-expect-error here, but the web TS is to old and confused
// as TS leaves this hint in the compiled JS for some reason.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore value is always set when rendering
exports.SharedThemeContext = react_1.default.createContext({});
// The hook for usage in functional components
const useSharedTheme = () => react_1.useContext(exports.SharedThemeContext);
exports.useSharedTheme = useSharedTheme;
const SharedThemeProvider = ({ children, currentTheme, }) => {
    return (react_1.default.createElement(exports.SharedThemeContext.Provider, { value: currentTheme }, children));
};
exports.SharedThemeProvider = SharedThemeProvider;
